import React, { useEffect, useState } from "react";
import "./instituteArticleQuestionTile.scss";
import { useTranslation } from "react-i18next";
import { RadioButtonGroup, RadioButton } from "@carbon/react";
import { CheckmarkFilled, ErrorFilled } from "@carbon/icons-react";
import { instituteArticlesData } from "../../instituteArticles/instituteArticlesData";

export default function InstituteArticleQuestionTile({
  question,
  answer,
  articleId,
  onAnswer,
  isRetrying,
}) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(answer?.answer || "");

  const rightAnswer = instituteArticlesData
    .find((a) => a.id === articleId)
    ?.questions.find((q) => q.id === question.id)?.rightAnswer;

  useEffect(() => {
    if (isRetrying) {
      setSelected("");
    } else if (answer?.answer) {
      setSelected(answer.answer);
    } else {
      setSelected("");
    }
  }, [answer, isRetrying]);

  const handleChange = (value) => {
    setSelected(value);
    if (!answer || isRetrying) {
      onAnswer({
        id: question.id,
        answer: value,
        completed: value === rightAnswer,
      });
    }
  };

  const showResult = Boolean(answer && !isRetrying);

  return (
    <div className="article_page_questions_main">
      <div className="article_page_questions_question">
        <div className="article_page_questions_question_text">
          {t(question.text)}
        </div>
        <RadioButtonGroup
          className="article_page_questions_question_answers"
          legendText=""
          required
          name={`radio-${question.id}`}
          orientation="vertical"
          valueSelected={selected}
          onChange={handleChange}
        >
          <RadioButton
            id={`checkbox-${question.id}-1`}
            labelText={t(question.answerA)}
            value="A"
            className={`${
              showResult && rightAnswer === answer?.answer
                ? "checkbox_right_answer"
                : showResult && rightAnswer !== answer?.answer
                ? "checkbox_wrong_answer"
                : ""
            }`}
          />
          <RadioButton
            id={`checkbox-${question.id}-2`}
            labelText={t(question.answerB)}
            value="B"
            className={`${
              showResult && rightAnswer === answer?.answer
                ? "checkbox_right_answer"
                : showResult && rightAnswer !== answer?.answer
                ? "checkbox_wrong_answer"
                : ""
            }`}
          />
          <RadioButton
            id={`checkbox-${question.id}-3`}
            labelText={t(question.answerC)}
            value="C"
            className={`${
              showResult && rightAnswer === answer?.answer
                ? "checkbox_right_answer"
                : showResult && rightAnswer !== answer?.answer
                ? "checkbox_wrong_answer"
                : ""
            }`}
          />
          <RadioButton
            id={`checkbox-${question.id}-4`}
            labelText={t(question.answerD)}
            value="D"
            className={`${
              showResult && rightAnswer === answer?.answer
                ? "checkbox_right_answer"
                : showResult && rightAnswer !== answer?.answer
                ? "checkbox_wrong_answer"
                : ""
            }`}
          />
        </RadioButtonGroup>
      </div>
      {showResult && (
        <div
          className={`article_page_questions_question_explanation ${
            answer?.completed ? "rightAnswer" : "wrongAnswer"
          }`}
        >
          <p className="">
            {answer?.completed ? (
              <CheckmarkFilled
                aria-label=""
                fill="green"
                className="completed_icon"
              />
            ) : (
              <ErrorFilled
                aria-label=""
                fill="red"
                className="completed_icon"
              />
            )}
            {t(question.explanation)}
          </p>
        </div>
      )}
    </div>
  );
}
